import { useState, useCallback } from 'react';

export const useDragAndDrop = (onFilesAdded) => {
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      onFilesAdded(e.dataTransfer.files);
    }
  }, [onFilesAdded]);

  return {
    dragActive,
    handleDrag,
    handleDrop
  };
};
